import { render, staticRenderFns } from "./welcomeRegistered.vue?vue&type=template&id=bb075678&scoped=true"
import script from "./welcomeRegistered.vue?vue&type=script&lang=js"
export * from "./welcomeRegistered.vue?vue&type=script&lang=js"
import style0 from "./welcomeRegistered.vue?vue&type=style&index=0&id=bb075678&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb075678",
  null
  
)

export default component.exports